import { Fragment } from 'react'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Divider from 'LuxKit/Divider'
import clsx from 'clsx'
import { fillArray } from 'lib/array/arrayUtils'
import { DayChip, DayPillsScrollContainer } from './DayItineraryCanvas'

interface Props {
  daysCount: number
}

function ItineraryLoadingState(props: Props) {
  const intl = useIntl()
  const { daysCount } = props

  const allLabel = intl.formatMessage({
    id: 'OnO6Hh9MUdwkfHzQvclU',
    defaultMessage: 'All',
    description: 'All days chip label in the itinerary loading skeleton',
  })

  return (
    <Group direction="vertical" gap={12}>
      <DayPillsScrollContainer>
        <Group direction="horizontal" gap={8}>
          <DayChip variant="filled" size="small" className={clsx({ isSelected: true })}>
            {allLabel}
          </DayChip>
          {fillArray(daysCount).map((i) => (
            <DayChip key={i} variant="filled" size="small">
              {intl.formatMessage(
                {
                  id: 'wUQJvZyMsxTSfUp5_tpg',
                  defaultMessage: 'Day {dayNumber}',
                  description: 'Day number chip label in the itinerary loading skeleton',
                },
                { dayNumber: i + 1 },
              )}
            </DayChip>
          ))}
        </Group>
      </DayPillsScrollContainer>
      <Group direction="vertical" gap={12}>
        {fillArray(daysCount).map((dayIndex) => (
          <Fragment key={dayIndex}>
            {dayIndex > 0 && <Divider kind="secondary" />}
            <Group direction="vertical" gap={8}>
              <TextLoadingBox width="30%" typography="body-medium" />
              <TextLoadingBox width="70%" typography="body-medium" />
              <TextLoadingBox width="100%" typography="body-medium" />
              <TextLoadingBox width="70%" typography="body-medium" />
              <TextLoadingBox width="100%" typography="body-medium" />
              <TextLoadingBox width="70%" typography="body-medium" />
              <TextLoadingBox width="100%" typography="body-medium" />
            </Group>
          </Fragment>
        ))}
      </Group>
    </Group>
  )
}

export default ItineraryLoadingState
